export default {"src":"/_next/static/media/twitter_icon.75419f26.svg","height":18,"width":23,"blurWidth":0,"blurHeight":0};